module.exports = __webpack_public_path__ + "static/img/home_adv.2736f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_adv.jpg
// module id = 2VM8
// module chunks = 1